import { render, staticRenderFns } from "./IList.vue?vue&type=template&id=6709b138&"
import script from "./IList.vue?vue&type=script&lang=js&"
export * from "./IList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports